import { Component, Input, OnInit } from '@angular/core';
import { Language } from '@shared/interfaces/account/language.interface';
import { BaseAuthComponent } from '@layouts/default/layouts/guest/pages/home/components/base-auth.component';
import { AccountService } from '@layouts/default/layouts/logged/pages/account/account.service';
import { User } from '@shared/models/user/user.model';
import { Response } from '@shared/models/response.model';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss'],
})
export class LangSwitcherComponent extends BaseAuthComponent implements OnInit {
  currentLang: string = this.storage.getLang() || 'en';
  @Input() isWhite: boolean;
  form: UntypedFormGroup = new UntypedFormGroup({});
  languages: Language[] = [
    {
      name: 'POLSKI',
      code: 'PL',
      flagSrc: 'assets/img/langs/pl.svg',
      id: 1,
      is_default: false,
    },
    {
      name: 'ENGLISH',
      code: 'EN',
      flagSrc: 'assets/img/langs/en.svg',
      id: 2,
      is_default: true,
    },
    {
      name: 'DEUTSCH',
      code: 'DE',
      flagSrc: 'assets/img/langs/de.svg',
      id: 7,
      is_default: false,
    },
    {
      name: 'FRANÇAIS',
      code: 'FR',
      flagSrc: 'assets/img/langs/fr.svg',
      id: 5,
      is_default: false,
    },
    {
      name: 'PORTUGAL',
      code: 'PT',
      flagSrc: 'assets/img/langs/pt.svg',
      id: 3,
      is_default: false,
    },
    {
      name: 'УКРАЇНСЬКИЙ',
      code: 'UK',
      flagSrc: 'assets/img/langs/uk.svg',
      id: 6,
      is_default: false,
    },
    {
      name: 'ESPAÑOL',
      code: 'ES',
      flagSrc: 'assets/img/langs/es.svg',
      id: 4,
      is_default: false,
    },
    {
      name: 'INDONESIA',
      code: 'ID',
      flagSrc: 'assets/img/langs/id.svg',
      id: 8,
      is_default: false,
    },
    {
      name: 'ITALIANO',
      code: 'IT',
      flagSrc: 'assets/img/langs/it.svg',
      id: 9,
      is_default: false,
    },
    {
      name: 'MALAYSIA',
      code: 'MS',
      flagSrc: 'assets/img/langs/ms.svg',
      id: 12,
      is_default: false,
    },
    {
      name: 'SLOVACA',
      code: 'SK',
      flagSrc: 'assets/img/langs/sk.svg',
      id: 11,
      is_default: false,
    },
    {
      name: 'ČEŠTINA',
      code: 'CZ',
      flagSrc: 'assets/img/langs/cz.svg',
      id: 13,
      is_default: false,
    },
    {
      name: 'ROMÂNĂ',
      code: 'RO',
      flagSrc: 'assets/img/langs/ro.svg',
      id: 14,
      is_default: false,
    },
    {
      name: 'DEUTSCH',
      code: 'DE',
      flagSrc: 'assets/img/langs/de.svg',
      id: 7,
      is_default: false,
    },
    {
      name: 'TÜRKÇE',
      code: 'TR',
      flagSrc: 'assets/img/langs/tr.svg',
      id: 10,
      is_default: false,
    },
  ];

  constructor(public accountService: AccountService) {
    super();
  }

  ngOnInit() {
    const langSub = this.languageService.languageEmitter.subscribe((el) => {
      const lang = this.languages.find((item) => item.code.toLowerCase() === el);
      this.form.get('language').patchValue(lang, {
        emitEvent: false,
      });
    });
    this.someSubscriptions.add(langSub);
  }

  changedLanguage(event) {
    this.languageService.updateCurrentLang(event.value.code);
    this.currentLang = event.value.code.toLowerCase();
    if (this.storage.user) {
      this.saveLanguage(event.value.id);
    }
  }

  saveLanguage(id: number) {
    this.loading = true;
    const pack = { language: id };
    const subChangeUserSaveLanguage = this.accountService
      .changeUser(pack, this.storage.user.id)
      .subscribe((res: Response<User>) => {
        this.storage.setUser(res.data);
        this.toast.success(
          this.translate.instant('ACCOUNT.language_saved'),
          this.translate.instant('ACCOUNT.language_success')
        );
        this.loading = false;
      }, this.onSaveLanguageError.bind(this));
    this.someSubscriptions.add(subChangeUserSaveLanguage);
  }

  onSaveLanguageError() {
    this.loading = false;
    this.toast.error(
      this.translate.instant('ACCOUNT.language_not_saved'),
      this.translate.instant('ACCOUNT.language_error')
    );
  }
}
